import axios, { CancelTokenSource } from 'axios'
import { useCallback, useRef } from 'react'

import { getCancelTokenSource } from '../../common/HTTPClient'

function useCancelToken() {
  const sourceRef = useRef<CancelTokenSource | null>(null)

  const cancelPending = useCallback(() => {
    if (!sourceRef.current) {
      return
    }

    const source = sourceRef.current
    source.cancel('Request was cancelled.')
    console.log('[wms] Request was cancelled.')
  }, [])

  const getSource = useRef(() => {
    sourceRef.current = getCancelTokenSource()

    return sourceRef.current
  })

  const clearSource = useRef(() => {
    sourceRef.current = null
  })

  const isCancel = useCallback(error => axios.isCancel(error), [])

  return {
    cancelPending,
    getSource: getSource.current,
    clearSource: clearSource.current,
    isCancel,
  }
}

export default useCancelToken
